import Swiper, { Navigation, Pagination } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination
    ]);
    new Swiper('.js-homepage-carousel2', {
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 12,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 28
            }
        }
    });
};
